export default function initSearchWidget()
{
    let widgets = document.querySelectorAll(".search-widget");
    if (!widgets.length) {
        return;
    }

    for (let widget of widgets) {
        initSearchButton(widget);
        initClearButton(widget);
    }
}

function initSearchButton(widget)
{
    let form = widget.querySelector("form");
    if (!form) {
        return;
    }

    let button = form.querySelector(".input-search .search-icon");
    if (!button) {
        return;
    }

    button.addEventListener("click", (ev) => form.submit());
}

function initClearButton(widget)
{
    let inputContainer = widget.querySelector(".input-search");
    if (!inputContainer) {
        return;
    }

    let input = inputContainer.querySelector("input");
    if (!input) {
        return;
    }

    let button = inputContainer.querySelector(".cross-icon");
    if (!button) {
        return;
    }

    button.addEventListener("click", (ev) => (input.value = ""));
}
